module.exports = __webpack_public_path__ + "Roboto-Black.b70f6931a7d38ba0e891.woff";


//////////////////
// WEBPACK FOOTER
// D:/V1/er.web.candidateconsole/src/assets/fonts/Roboto-Black.woff
// module id = ../../../../../src/assets/fonts/Roboto-Black.woff
// module chunks = styles